import styled from '@emotion/styled';

export const Centered = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
